<div class="relative pb-5">
    <div class="relative">
        <h2 class="text-xl text-center font-semibold">Daily Check-in</h2>
        <span
            nz-icon
            nzType="info-circle"
            class="!text-sub-text text-lg absolute top-1/2 -translate-y-1/2 right-0 cursor-pointer"
            (click)="gmRulesVisible = true"
        ></span>
    </div>

    <div class="text-sub-text text-center text-sm mt-2 mb-5">
        Daily check-in refreshes at {{refreshTime}}<span class="text-xs italic">({{userTz}})</span> every day.
    </div>
    <div *ngIf="!fetchingData" class="flex justify-between items-center overflow-x-auto gap-x-2.5">
        <div class="flex-1">
            <div class="w-full flex justify-between flex-1 items-center gap-x-2">
                <div
                    *ngFor="let item of dailyGm"
                    class="w-10 md:w-[64px] h-[56px] md:h-[80px] rounded-md flex flex-col justify-center items-center gap-y-1 text-2xs md:text-xs relative"
                    [ngClass]="{
                        '!bg-secondaryCard': item.isChecked || item.isMissing,
                        'bg-gradient-to-b from-gradientStart to-gradientEnd': !item.isChecked && !item.isMissing
                    }"
                >
                    <!-- 第二天、第七天 -->
                    <ng-container *ngIf="item.badge">
                        <img
                            *ngIf="!item.isChecked"
                            [src]="item.badge.icon_enabled"
                            class="w-[22px] md:w-10 h-[22px] md:h-10 absolute left-3 md:left-5 top-4 md:top-[22px] z-10"
                        />

                        <div *ngIf="!item.isChecked" class="flex-center-center mt-1">
                            <img src="/assets/imgs/icon/sun-shadow.png" class="w-[22px] h-[22px] md:w-10 md:h-10 top-2.5 left-1 absolute" />

                            <!-- 正常未签到 -->
                            <ng-container *ngIf="!item.isMissing">
                                <div
                                    class="font-semibold h-3 px-1 text-transparent text-[9px] bg-black bg-opacity-50 w-fit leading-3 rounded-lg top-3 left-[10px] z-10 md:left-[28px] absolute"
                                >
                                    <span class="colorful-text font-semibold">+{{item.points + item.badge.points}}</span>
                                </div>
                            </ng-container>

                            <!-- 是过去的某天，且未签到 -->
                            <img *ngIf="item.isMissing" src="/assets/imgs/icon/close.png" class="w-6 h-6 absolute bottom-0 left-1/2 -translate-x-1/2" />

                            <img *ngIf="item.isChecked" class="w-6 h-6" src="/assets/imgs/icon/check.png" alt="" />
                        </div>

                        <!-- 正常签到 -->
                        <img *ngIf="item.isChecked" class="w-6 h-6" src="/assets/imgs/icon/check.png" alt="" />
                    </ng-container>

                    <!-- 其他天 -->
                    <ng-container *ngIf="!item.badge">
                        <img *ngIf="!item.isChecked" [src]="'/assets/imgs/icon/sun-v2.png'" class="w-[22px] h-[22px] md:w-10 md:h-10" />

                        <!-- 正常未签到 -->
                        <ng-container *ngIf="!item.isChecked">
                            <span *ngIf="!item.isMissing" class="font-semibold">+ {{item.points}}</span>

                            <!-- 过去的某天，且未签到 -->
                            <img *ngIf="item.isMissing" class="w-6 h-6" src="/assets/imgs/icon/close.png" alt="" />
                        </ng-container>

                        <!-- 正常签到 -->
                        <img *ngIf="item.isChecked" class="w-6 h-6" src="/assets/imgs/icon/check.png" alt="" />
                    </ng-container>
                </div>
            </div>
            <div class="w-[calc(100%-30px)] md:w-[calc(100%-44px)] mx-auto mt-2 flex justify-between items-center relative">
                <div
                    *ngFor="let item of dailyGm"
                    class="w-2.5 h-2.5 rounded-full transition-colors relative z-10"
                    [ngClass]="item.isChecked? 'bg-black': 'bg-white border border-black'"
                ></div>
                <div class="w-full h-0.5 bg-black bg-opacity-10 absolute left-0 top-1"></div>
                <div
                    class="h-1 progress-bar absolute left-0 top-1 transition-all"
                    [ngStyle]="{
                        'background': backgroundStr,
                        'max-width':'100%',
                        width: ((checkWeekInfo$ | async)?.login_streak - 1) / 6 * 100 + '%'
                    }"
                ></div>
            </div>

            <div class="w-[calc(100%-6px)] md:w-[calc(100%-22px)] mx-auto mt-2 flex-between-center">
                <div *ngFor="let item of dailyGm" class="text-2xs md:text-xs" [ngClass]="{'text-sub-text': item.isChecked, 'text-black': !item.isChecked}">
                    {{item.name}}
                </div>
            </div>
        </div>
    </div>

    <nz-skeleton *ngIf="fetchingData" [nzActive]="true"></nz-skeleton>

    <div *ngIf="!fetchingData" class="flex justify-center items-center h-[36px] md:h-[56px] mt-7">
        <button
            nz-button
            nzType="primary"
            [disabled]="todayChecked"
            [@tada]="animationState"
            [nzLoading]="submitting"
            [nzSize]="'large'"
            class="!px-8"
            (click)="checkIn()"
        >
            <span class="font-semibold" [ngClass]="{'colorful-text': !todayChecked}">
                <ng-container *ngIf="!isStartNewStreakMode">Check In</ng-container>
                <ng-container *ngIf="isStartNewStreakMode">Start New Streak</ng-container>
            </span>
        </button>
    </div>
</div>
<nz-modal [(nzVisible)]="gmRulesVisible" nzCentered nzTitle="Check-in Rules" [nzFooter]="null" (nzOnCancel)="gmRulesVisible = false">
    <ng-container *nzModalContent>
        <p>1. Each address can check in once per day and receive corresponding point rewards.</p>
        <p>2. If you sign in continuously on the 2nd and the 7th day, you will earn more points and receive continuous login badge rewards.</p>
        <p>
            3. Each 7 days is a cycle. When the continuous sign-in is interrupted, the points accumulated previously will be retained, and the number of
            consecutive sign-in days will start to recount.
        </p>
    </ng-container>
</nz-modal>
